import styles from "./Payment.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import { HiOutlineDocumentText } from "react-icons/hi2";

const colorPresets = [
  { rgb: "117, 115, 240" }, // blue

  { rgb: "60, 216, 85" },
  { rgb: "222, 152, 76" }, // Orange
  { rgb: "150, 125, 130" }, // Greyish Mauve
  { rgb: "106, 212, 218" }, // green
];

const baseData = [
  {
    name: "John Steeve",
    paidDate: "03/06/2025",
    amount: "INR 25000",
  },
  {
    name: "John Steeve",
    paidDate: "03/06/2025",
    amount: "INR 25000",
  },
  {
    name: "John Steeve",
    paidDate: "03/06/2025",
    amount: "INR 25000",
  },
  {
    name: "John Steeve",
    paidDate: "03/06/2025",
    amount: "INR 25000",
  },
];

const Payment = () => {
  const paymentData = baseData.map((item, index) => {
    const color = colorPresets[index % colorPresets.length];
    const textColor = `rgb(${color.rgb})`;
    const bgColor = `rgba(${color.rgb}, 0.15)`;
    return {
      ...item,
      bgColor,
      textColor,
      circleBgColor: textColor,
      circleTextColor: "#fff",
    };
  });

  const handleViewAll = () => {
    console.log("View All Payments clicked");
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <HeadingAndIcon
          icon={<HiOutlineDocumentText />}
          heading="Payment in last 14 Days"
        />
        <span className={styles.viewAll} onClick={handleViewAll}>
          View All
        </span>
      </div>

      <div className={styles.list}>
        {paymentData.map((item, i) => (
          <div
            key={i}
            className={styles.dataCard}
            style={{ backgroundColor: item.bgColor }}
          >
            <LogoWithName
              name={item.name}
              dateRange={`Paid On : ${item.paidDate}`}
              color={item.textColor}
              bgColor={item.circleBgColor}
              circleTextColor={item.circleTextColor}
            />
            <span className={styles.dateText} style={{ color: item.textColor }}>
              {item.amount}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Payment;
